import { z } from 'zod'

// @TODO: Implement assertions type
export const assertions = z.any().optional()
